import * as React from 'react'
function SvgCalendar(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M14 4v4h12V4h4v4h4c1.106 0 2 .894 2 2v24c0 1.106-.894 2-2 2H6c-1.106 0-2-.894-2-2V10c0-1.106.894-2 2-2h4V4h4zm18 10H8v18h24V14zM16 24v4h-4v-4h4zm6 0v4h-4v-4h4zm6 0v4h-4v-4h4zm-12-6v4h-4v-4h4zm6 0v4h-4v-4h4zm6 0v4h-4v-4h4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgCalendar
